import * as leadsApis from './leads/api';

const combinedApis = {
  ...leadsApis,
};

export default combinedApis;
